import { render } from "./GamificationLeaderboardMonthly.vue?vue&type=template&id=4bf52c53"
import script from "./GamificationLeaderboardMonthly.vue?vue&type=script&lang=js"
export * from "./GamificationLeaderboardMonthly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__